import React, { useState, useEffect } from "react";
import "./../../SCSS/ProductType/_productNine.scss";
import empty_favourite from "./../../assets/Icon/empty_favourite.svg";
import fulfill_favourite from "./../../assets/Icon/fulfill_favourite.svg";
import Heading7 from "../Font/Heading7";
import Text4 from "../Font/Text4";
import OldPrice from "../Font/OldPrice";
import Price from "../Font/Price";
import RatingBlock from "../MostSharedComponent/RatingBlock";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  loadAddToWishlist,
  loadApplyFilterProductsData,
  loadDeleteFromWishlist,
  loadWishlistData,
} from "../../redux/appAction";
import { BiSearch } from "react-icons/bi";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";
import {
  selectedCompareProductStatus,
} from "../helpers/utils/compareProductsFilter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { addToCart } from "../../services/cart.service";
import { loadCartData } from "../../redux/appAction";
import VariantOptions from "./VariantOptions";
import { productUrlHelper } from "../helpers/utils/productUrlHelper";
import DeliveryTimeArea from "../MostSharedComponent/DeliveryTimeArea";
import TamaraLogoBox from "../MostSharedComponent/TamaraLogoBox";
import { checkWishList } from "../helpers/utils/wishListHelper";
import { titleChange } from "../helpers/utils/titleNameChange";
import MizaAndQitaf from "../MostSharedComponent/MizaAndQitaf";
import ProductLabel from "../MostSharedComponent/ProductLabel";
import PLPdiscountBox from "../MostSharedComponent/PLPdiscountBox";
import { ImageResize } from "../helpers/utils/imageResize";
import { cartEvents } from "../helpers/utils/ga/cartEvents";
import { checkoutEvents } from "../helpers/utils/ga/checkoutEvents";
import cancel_grey from "./../../assets/Icon/cancel_grey.svg";
import LazyImageForProduct from "../MostSharedComponent/LazyImageForProduct";
import AddtoCartCategory from "../Buttons/AddtoCartCategory";
import useCartErrorMessage from "../helpers/hooks/useCartErrorMessage";
import SoldOutCategoryLabel from "../MostSharedComponent/SoldOutCategoryLabel";
import ProductDeliveryType from "../MostSharedComponent/ProductDeliveryType";
import { impressionEvents } from "../helpers/utils/ga/impressionEvents";
import SubscribeSection from "../Meza/SubscribeSection";
import SubsSectionContent from "../Meza/SubsSectionContent";

const currentLanguageAr = (localStorage.getItem("i18next") || "en") === "ar";

function ProductNine({
  product,
  handleChangeProductPopup,
  updateCompareProduct,
  handleChangeCartPopup,
  redirectToPdpPage,
  onTouchStart = () => { },
  onTouchMove = () => { },
  onTouchEnd = () => { },
  btnType,
  outOfStockConfiguration,
  productIndex,
  screenName,
  isCompareShow = true,
  removeProductFromCompare,
  availablityData,
  productIdData, 
  customerDetails
}) {

  const { setCartErr } = useCartErrorMessage();

  const dispatch = useDispatch();
  // const getCompareProductList = useSelector(
  //   (state) => state.appData.getCompareProductList
  // );
  useEffect(() => {
    product.is_price_hide = product?.options?.find((x) => {
      if (x.code === 'is_price_hide') {
        return x.visibility;
      }
      return false;
    });
  }, [product]);
  // const [rating, setRating] = useState(0);
  const [sizeButtonIndex, setSizeButtonIndex] = useState(null);

  const [isFavouriteHover, setIsFavouriteHover] = useState(false);
  const [isFavourite, setIsFavourite] = useState(false);
  const [count, setCount] = useState(0);
  const [loaderOn, setLoaderOn] = useState(false);
  const [spinnerOn, setSpinnerOn] = useState(false);
  const [clickData, setClickData] = useState();
  const [clickSkuData, setClickSkuData] = useState();
  // const [productImages, setProductImages] = useState([]);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    arrows: false,
    initialSlide: currentLanguageAr ? -1 : 0,
  };
  const { t } = useTranslation();
  const navigate = useNavigate()

  const wishlistData = useSelector((state) => state.appData.wishlistData);

  useEffect(() => {
    setIsFavourite(checkWishList(wishlistData, product?.sku));
  }, [wishlistData]);

  // useEffect(() => {
  //   const productList = [...(product?.media?.image?.screenshots || [])];
  //   if (currentLanguageAr) {
  //     productList?.reverse();
  //   }
  //   setProductImages(productList);
  // }, [product?.media?.image?.screenshots]);
  const handleFavourite = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (isFavourite) {
      setIsFavourite(false);
      setCount(count + 1);
      
    } else {
      setIsFavourite(true);
      setCount(count + 1);
     
    }
  };
  useEffect(() => {
    const data = {
      items: [product.sku],
    };
    if (isFavourite) {
      if (count > 0) {
        const addToWishlistData = dispatch(loadAddToWishlist(data, t)).then(
          (res) => {
            checkoutEvents.addToWishlist(product, screenName);
            dispatch(loadWishlistData());
          }
        );
      }
    } else {
      if (count > 0) {
        if (!isFavourite) {
          checkoutEvents.removeFromWishlist(product, screenName);
          removeFromWL(product.sku);
        }
      }
    }
  }, [isFavourite]);

  const removeFromWL = (sku) => {
    const data = {
      items: [sku],
    };
    const deleteFromWishlistData = dispatch(loadDeleteFromWishlist(data, t)).then(
      (res) => {
        dispatch(loadWishlistData());
      }
    );
  };

  // const handleRating = (score) => {
  //   setRating(score);
  // };
  const targetPrice = product?.price_rounded;
  const matchedProduct = product?.variants?.filter(product => product.price_rounded === targetPrice);
  const newMatchPrice = matchedProduct?.length > 1 ? matchedProduct?.[0] : matchedProduct?.[0];
  const screenSize = matchedProduct && matchedProduct[0]?.options?.screen_size;
  const seletcedScreenSize = product?.variantOptions?.[0].attribute?.options.filter(product => product.id === screenSize);
  const defaultSku = matchedProduct && matchedProduct[0]?.sku;
  useEffect(() => {
    const boxes = document.querySelectorAll('.productNine__name');
    let maxHeight = 0;

    // Calculate the maximum height among all the divs with class '.productNine__name'
    boxes.forEach((box) => {
      const boxHeight = box.offsetHeight;
      maxHeight = Math.max(maxHeight, boxHeight);
    });

    // Set the calculated maxHeight to all divs with class '.productNine__name'
    boxes.forEach((box) => {
      box.style.height = `${maxHeight}px`;
    });
  }, []);
  const sizeButtonClick = (sizeIndex) => {
    product.sku = product?.variants[sizeIndex]?.sku;
    product.name = product?.variants[sizeIndex]?.name;
    product.description = product?.variants[sizeIndex]?.description;
    product.price = product?.variants[sizeIndex]?.price;
    product.currency = product?.variants[sizeIndex]?.currency;
    product.price_rounded = product?.variants[sizeIndex]?.price_rounded;
    product.discounted_price = product?.variants[sizeIndex]?.discounted_price;
    product.discounted_price_rounded = product?.variants[sizeIndex]?.discounted_price_rounded;
    product.discounted_price_from = product?.variants[sizeIndex]?.discounted_price_from;
    product.discounted_price_to = product?.variants[sizeIndex]?.discounted_price_to;
    product.is_count_down = product?.variants[sizeIndex]?.is_count_down;
    product.stock = product?.variants[sizeIndex]?.stock;
    product.item_type = product?.variants[sizeIndex]?.item_type;
    product.meza = product?.variants[sizeIndex]?.meza;
    product.qitaf = product?.variants[sizeIndex]?.qitaf;
    product.eligible_for_tabby = product?.variants[sizeIndex]?.eligible_for_tabby;
    product.enable_shipping = product?.variants[sizeIndex]?.enable_shipping;
    product.additional_estimated_day = product?.variants[sizeIndex]?.additional_estimated_day;
    product.current_time = product?.variants[sizeIndex]?.current_time
    setSizeButtonIndex(sizeIndex);
  };
  useEffect(() => {
    if (product?.variants && product?.variants.length > 0 && sizeButtonIndex >= 0) {
      setClickData(product?.variants[sizeButtonIndex]?.name);
      setClickSkuData(product?.variants[sizeButtonIndex]?.sku);
    }
  }, [product, sizeButtonIndex]);
  const stringToCheck = product?.name;
  const regex = /-(.+)/;
  const hasAnythingAfterDash = regex.test(stringToCheck);


  const AddProductToCart = (sku) => {
    // impressionEvents.impressionAddToCart(
    //   product,
    //   count,"home"
    // );
    setLoaderOn(true);
    if (product?.variants && product?.variants.length > 0 && sizeButtonIndex && sizeButtonIndex >= 0) {
      sku = product.variants[sizeButtonIndex].sku;
    }

    const data = {
      items: [
        {
          sku: sku,
          qty: 1,
          id: product?.id
        },
      ],
    };

    addToCart(data)
      .then((res) => {
        setSpinnerOn(true)
        dispatch(loadCartData()).then((item) => {
          cartEvents.addToCart(product, item?.id, screenName)
          setSpinnerOn(false)
          handleChangeCartPopup(true);
        });
      })
      .catch((err) => {
        setCartErr({ stock: product?.stock, error: err?.response?.data });
        setLoaderOn(false);
      })
      .finally(() => {
        setLoaderOn(false);
      });
  };

  // const getSpecificDayDate = (day) => {
  //   const tomorrow = moment().add(day, "days");
  //   return tomorrow.format("DD, MMMM");
  // };

  // const isOutOfStock = product?.orderType === 'out-of-stock' || product?.stock === 0;

  return (
    <div
      key={product.id}
      className="productNine__block"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onClick={() => {navigate(productUrlHelper(product?.english_name, product?.sku));
        impressionEvents.impressionProductClick(
          "select_item", product
        );
      }}
    >
      <div className="productNine__header">
        {/* <div className="productNine__new__sticker__block">
          <p className="productNine__new__sticker__text">{t("New")}</p>
        </div> */}        
        <PLPdiscountBox product={product} t={t} />
        {isCompareShow ? <>  <img
          onMouseEnter={() => setIsFavouriteHover(true)}
          onClick={handleFavourite}
          onMouseLeave={() => setIsFavouriteHover(false)}
          className={
            !isFavourite
              ? "productOne__favourite__icon"
              : "productOne__favourite__icon__disable"
          }
          src={isFavouriteHover ? fulfill_favourite : empty_favourite}
          alt=""
        />
          <img
            onClick={handleFavourite}
            className={
              isFavourite
                ? "productOne__favourite__icon"
                : "productOne__favourite__icon__disable"
            }
            src={fulfill_favourite}
            alt=""
          /></> :
          <div className="product__comparison__close__icon__block">
            <img
              src={cancel_grey}
              alt=""
              className="product__comparison__close__icon"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                removeProductFromCompare(product.id)
              }}
            />
          </div>
          }
      </div>
      <div className="productNine__content">
        <Link
          className="productNine__name__link"
          to={productUrlHelper(product?.english_name, product?.sku)}
        >
          <div className="product__pics__area">
            <div
              className="productNine__image__slider"
            // to={productUrlHelper(product?.english_name, product?.sku)}
            >
              {/* <div onClick={()=>redirectToPdpPage(product.sku)}> */}
              <Slider {...settings}>
                {[product?.baseImage]?.map((img, index) => (
                  <div key={index} className="">
                    <LazyImageForProduct
                      product={product}
                      srcSetReSize={ImageResize}
                      alt={img + index}
                      className=""
                      onClickEvent={true}
                      redirectToPdpPage={redirectToPdpPage}
                    />
                  </div>
                ))}
              </Slider>
              {/* </div> */}
              {/* <AwesomeSlider transitionDelay={0.2} mobileTouch={true} infinite={true}>
              {product?.media?.image?.screenshots?.map((img, index) => (
                <div key={index} className="_product__container_image">
                  <img src={img.image} alt={img.image + index} />
                </div>
              ))}
            </AwesomeSlider> */}
            </div>
            <ProductLabel product={product} labelType="plp" />
            <SoldOutCategoryLabel
              t={t}
              product={product}
              outOfStockConfiguration={outOfStockConfiguration}
              productIdData={productIdData}
            />
          </div>
          <div className="plp__tamara__box mb-2 mt-1">
            <TamaraLogoBox
              product={product}
            />
          </div>

          {/* <Link
            className="productNine__name__link"
            to={productUrlHelper(product?.english_name, product?.sku)}
          > */}
          {/* {newMatchPrice ? 
          <p className="productNine__name"> {titleChange(`${newMatchPrice?.name}`)}</p>
          : <p className="productNine__name"> {titleChange(`${product.name}`)}</p>
          } */}
          {/* {newMatchPrice?.name === product?.name ? 
            <p className="productNine__name">{titleChange(`${newMatchPrice?.name}`)}</p>
            :
              newMatchPrice?.name !== undefined ? (
                <p className="productNine__name">{titleChange(`${newMatchPrice?.name}`)}</p>
              ) : (
                <p className="productNine__name">{titleChange(`${product?.name}`)}</p>
              )
            
          } */}
          {/* <p className="productNine__name"> {titleChange(`${product.name}`)}</p> */}
          {/* </Link> */}
          
          {/* <Heading6 text={titleChange(product.name)} marginBottom={10} /> */}
          {/* <p className="productNine__name">{titleChange(productName)}</p> */}
          {clickData ? <p className="productNine__name">{titleChange(clickData)}</p> 
          : newMatchPrice ? <p className="productNine__name">{titleChange(newMatchPrice?.name)}</p> 
          : <p className="productNine__name">{titleChange(product?.name)}</p>  }
          <ProductDeliveryType
            product={product}
            availablityData={availablityData}
            t={t}
          />
          <div className="plp__mezza__reward d-flex justify-content-between align-items-center mb-2">
            <MizaAndQitaf product={product} />
          </div>
          <div className="nineDesk_product_grid_view_pricebox">
            {
              !product?.is_price_hide &&
              <>
                <OldPrice
                  oldPrice={product?.price_rounded}
                  price={
                    product.discounted_price_rounded === null
                      ? product.price_rounded
                      : product.discounted_price_rounded
                  }
                  size="text3"
                  color="#444444"
                  // marginBottom={10}
                  // lineThrough={true}
                  span={true}
                  currency="SAR"
                />
                <Price
                  price={
                    product.discounted_price_rounded === null
                      ? product.price_rounded
                      : product.discounted_price_rounded
                  }
                  // marginLeft={5}
                  // marginBottom={10}
                  size="heading6"
                  span={true}
                  currency="SAR"
                />
              </>
            }
          </div>
        </Link>
        <RatingBlock rating={6} totalRatings={2222} className="mt-1" />
        {/* <div className="mt-1">
          <RatingBlock rating={6} totalRatings={2222} />
        </div> */}
        <div className="size__button__block">
          {product?.variantOptions && (
            <VariantOptions
              sizeButtonClick={sizeButtonClick}
              sizeButtonIndex={sizeButtonIndex}
              variantOptions={product?.variantOptions}
              product={product}
            />
          )}
        </div>
        <div className="productNine__feature__block">
          {product.productFeatures && (
            <>
              {product.productFeatures.map((feature, featureIndex) => {
                return (
                  <div key={featureIndex} className="feature__text__block">
                    <div className="feature__bullet"></div>
                    <Text4 text={feature.text} />
                  </div>
                );
              })}
            </>
          )}
        </div>
        <div className="delivery-time-area">
          {product?.additional_estimated_day !== undefined && (
            <DeliveryTimeArea
              additional_estimated_day={product?.additional_estimated_day}
            />
          )}
        </div>
        {!product?.hide_subscriber_price && (
          <SubscribeSection>
            <SubsSectionContent
              t={t}
              meza_subscriber_price={product?.meza_subscriber_price}
              user={customerDetails}
              discounted_price={product.discounted_price_rounded}
              og_price={product.price_rounded}
            />
          </SubscribeSection>
        )}
        <span onClick={e => { e.stopPropagation(); e.preventDefault(); }}>
          {product?.is_bundle_enable === 1 ? (
            <Link
              to={productUrlHelper(product?.english_name, product?.sku)}
              aria-label={`${titleChange(product.name)}`}
              style={{ textDecoration: 'none' }}
            >
              <AddtoCartCategory
                product={product}
                AddProductToCart={AddProductToCart}
                outOfStockConfiguration={outOfStockConfiguration}
                loaderOn={loaderOn || spinnerOn}
                productIdData={productIdData}
                matchedProduct={matchedProduct}
              />
            </Link>
          ) : (
            <AddtoCartCategory
              product={product}
              AddProductToCart={AddProductToCart}
              outOfStockConfiguration={outOfStockConfiguration}
              loaderOn={loaderOn || spinnerOn}
              productIdData={productIdData}
              matchedProduct={matchedProduct}
            />
          )}
        </span>
        {isCompareShow && <div className="productNine__quickView__compare__block"
          onClick={e => { e.stopPropagation(); e.preventDefault(); }}
        >
          <button
            onClick={() => handleChangeProductPopup(true, product)}
            className="productNine__button__block"
          >
            <BiSearch className="search_icon shortlink_icon" />
            <Heading7 text={t("Quick_View")} />
          </button>
          <button
            onClick={() => updateCompareProduct(true, product)}
            className={`productNine__button__block ${selectedCompareProductStatus(product.id) === true
              ? `active_compare_btn`
              : ``
              }`}
          >
            <HiOutlineSwitchHorizontal className="compare_icon shortlink_icon" />
            <Heading7 text={t("Compare")} />
          </button>
        </div>
         }
      </div>
    </div>
  );
}

export default ProductNine;
